import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  usernameLabel: {
    id: 'studio.JCIgkj',
    defaultMessage: 'Username',
  },
  usernameHelp: {
    id: 'studio.v9WALR',
    defaultMessage: 'The username for HTTP basic authentication',
  },
  passwordLabel: {
    id: 'studio.5sg7KC',
    defaultMessage: 'Password',
  },
  passwordHelp: {
    id: 'studio.NKioch',
    defaultMessage: 'The password for HTTP basic authentication',
  },
});
